import React from "react";
import HolidayTypePage from "../../../component/holiday-type/HolidayTypeList";

function HolidayType() {
  return (
    <div className="page-body">
      <HolidayTypePage />
    </div>
  );
}

export default HolidayType;
